import type { ImportRequest } from "../stores/file-to-storydoc-generation.store";

export const isSameImportRequest = (
  local: {
    pdfUrl: string | null;
    pages: number[];
    selectedDesignSystemId: string | null;
  },
  gen: { request: ImportRequest | null; selectedDesignSystemId: string | null },
): boolean =>
  gen.request != null &&
  gen.request.pdfUrl === local.pdfUrl &&
  gen.request.pages.join(",") === local.pages.join(",") &&
  gen.selectedDesignSystemId === local.selectedDesignSystemId;
